import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { AnimationOptions,LottieComponent } from 'ngx-lottie'; 
@Component({
  selector: 'app-loading',
  imports: [LottieComponent ,CommonModule],
  templateUrl: './loading.html',
  styleUrl: './loading.css',
})
export class Loading {
  isLoading = true;

  loadingAnimation: AnimationOptions = {
    path: 'assets/lottie/loading-animation.json'
  };
}
